const PHRASES = [
  "Built by outdoorsmen",
  "Driven by possibility",
  "Rooted in the land",
  "The future of outdoor recreation",
];

const Diamond = () => (
  <span
    aria-hidden="true"
    className="mx-6 inline-block h-[6px] w-[6px] rotate-45 bg-[#c6a664]/70 align-middle"
  />
);

/**
 * A slow, single editorial marquee band.
 */
export const Marquee = () => {
  // Duplicated once so the -50% translate loops seamlessly.
  const loop = [...PHRASES, ...PHRASES];
  return (
    <div
      aria-hidden="true"
      data-testid="brand-marquee"
      className="reveal pointer-events-none relative w-full overflow-hidden border-y border-[#c6a664]/15 bg-[#0a130e]/40 py-4 backdrop-blur-sm"
      style={{ animationDelay: "1.9s" }}
    >
      <div className="marquee-track">
        {loop.map((phrase, i) => (
          <span
            key={i}
            className="font-body text-xs uppercase tracking-[0.4em] text-[#c6a664]/60 md:text-sm"
          >
            {phrase}
            <Diamond />
          </span>
        ))}
      </div>
    </div>
  );
};
